import MuiRadio, { RadioProps } from '@mui/material/Radio';
import FormControlLabel from '../FormControlLabel';

export interface IRadioProps extends RadioProps {
  label?: string | number | React.ReactElement;
  error?: boolean;
  helperText?: string;
}

const Radio = (props: IRadioProps): JSX.Element => {
  return <FormControlLabel disabled={props.disabled}
    control={
      <MuiRadio
        {...props}
        color="primary"
        size="small"
      ></MuiRadio>
    }
    label={props.label || ""}
    labelPlacement="end"
  ></FormControlLabel>
};

export default Radio;
